import { ButtonHTMLAttributes, ForwardedRef, forwardRef, ReactNode } from 'react';

import { clsx } from 'clsx';

import { Loader } from '@shared/ui/Loader';

import cls from './Button.module.scss';

type ButtonVariant = 'clear' | 'accent' | 'primary' | 'secondary' | 'tertiary';
type ButtonSize = 's' | 'm' | 'l' | 'auto';

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  className?: string;
  variant?: ButtonVariant;
  size?: ButtonSize;
  isLoading?: boolean;
  disabled?: boolean;
  children?: ReactNode;
  fullWidth?: boolean;
  addonLeft?: ReactNode;
  addonRight?: ReactNode;
  loadingButton?: boolean;
  testId?: string;
};

export const Button = forwardRef((props: ButtonProps, ref: ForwardedRef<HTMLButtonElement>) => {
  const {
    className,
    children,
    variant = 'accent',
    disabled,
    fullWidth,
    size = 'm',
    addonLeft,
    addonRight,
    isLoading,
    loadingButton,
    testId,
    ...otherProps
  } = props;

  const mods = {
    [cls.disabled]: disabled,
    [cls.fullWidth]: fullWidth,
    [cls.isLoading]: isLoading,
    [cls.withAddon]: Boolean(addonLeft) || Boolean(addonRight)
  };

  return (
    <button
      data-testid={testId}
      className={clsx(cls.button, className, mods, [cls[variant], cls[size]])}
      disabled={disabled}
      {...otherProps}
      ref={ref}
    >
      {addonLeft && <div className={cls.addonLeft}>{addonLeft}</div>}
      <div className={cls.label}>{children}</div>
      {loadingButton && <Loader className={cls.loader} />}
      {addonRight && <div className={cls.addonRight}>{addonRight}</div>}
    </button>
  );
});
